(() => {
  const home = document.getElementById('dcomHome');
  const reviews = home?.querySelector('.dcom-home__reviews');
  const score = home?.querySelector('[data-dcom-review-score]');
  const label = home?.querySelector('[data-dcom-review-label]');
  if (!reviews || !score || !label) return;
  const link = score.closest('a');
  const actionLabel = link?.getAttribute('aria-label') || label.textContent;
  const formatter = new Intl.NumberFormat(document.documentElement.lang, { maximumFractionDigits: 2 });
  let frame = 0;
  const update = () => {
    frame = 0;
    const average = Number(reviews.querySelector('.junip-product-review-average')?.textContent.trim().replace(',', '.'));
    const count = reviews.querySelector('.junip-product-review-count')?.textContent.trim();
    if (!Number.isFinite(average) || average <= 0 || average > 5 || !count || !/[1-9]/.test(count)) return;
    score.textContent = `${formatter.format(average)} / 5`;
    score.hidden = false;
    label.textContent = count;
    link?.setAttribute('aria-label', `${score.textContent} · ${count}. ${actionLabel}`);
  };
  const observer = new MutationObserver(() => {
    if (!frame) frame = requestAnimationFrame(update);
  });
  observer.observe(reviews, { childList: true, subtree: true, characterData: true });
  update();
})();
